import * as React from 'react';
import ContentModal from '../components/content-modal';
import styled from 'styled-components/native';
import config from './config';
import SelectPhotos from '../../components/bcrs/select-photos';

const Screen = styled(ContentModal)`
  position: absolute;
  top: ${config.modals.top}px;
  right: 15px;
  width: 33vw;
`;

export default function BCRSSelectPhotosScreen() {
  return (
    <Screen title="Upload Photos">
      <SelectPhotos />
    </Screen>
  );
}
